import React from "react";
import {Route, Redirect} from "react-router-dom";
import {pathnames as P} from '../../constants/pathnames';

const ProtectedRoute = ({
                          component: Component,
                          allow,
                          redirectTo = "/",
                          ...rest
                        }) => (

  <Route
    {...rest}
    render={(props) =>
      allow ? <Component {...props} /> : <Redirect to={P.MAIN_MENU} />
    }
  />
);

export default ProtectedRoute;
